/**
 * Mantine modals üzerinde yerli `window.confirm` yerine kullanılan helper.
 * Native tarayıcı diyaloglarını projeden kaldırmak için merkezi nokta.
 *
 * Kullanım:
 *   if (!(await confirmAction({ title: "Silinsin mi?", danger: true }))) return;
 */
import type { ReactNode } from "react";
import { modals } from "@mantine/modals";

export type ConfirmActionOptions = {
  title?: string;
  message?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
};

export function confirmAction(opts: ConfirmActionOptions = {}): Promise<boolean> {
  const {
    title = "Emin misiniz?",
    message,
    confirmLabel,
    cancelLabel = "İptal",
    danger = false,
  } = opts;

  return new Promise<boolean>((resolve) => {
    const config: Parameters<typeof modals.openConfirmModal>[0] = {
      title,
      centered: true,
      children: message ?? null,
      labels: {
        confirm: confirmLabel ?? (danger ? "Sil" : "Onayla"),
        cancel: cancelLabel,
      },
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    };
    if (danger) {
      config.confirmProps = { color: "red" };
    }
    modals.openConfirmModal(config);
  });
}

/** Kısa yol: silme onayı için ön ayarlı varyant. */
export function confirmDelete(
  message: ReactNode,
  opts: Omit<ConfirmActionOptions, "message" | "danger"> = {},
): Promise<boolean> {
  const next: ConfirmActionOptions = {
    title: opts.title ?? "Silme onayı",
    confirmLabel: opts.confirmLabel ?? "Sil",
    message,
    danger: true,
  };
  if (opts.cancelLabel !== undefined) {
    next.cancelLabel = opts.cancelLabel;
  }
  return confirmAction(next);
}
